import { useState } from 'react';

import { ArrowRightCircleIcon } from 'lucide-react';

interface DateInputProps {
  onUpdateDate: (v: string) => void;
  initialValue: string;
  isLoading: boolean;
}

const DateInput: React.FC<DateInputProps> = ({ onUpdateDate, initialValue, isLoading }) => {
  const [value, setValue] = useState<string>(initialValue);

  // Function to handle text change
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSubmit = () => {
    if (value !== initialValue) {
      onUpdateDate(value);
    }
  };

  // Function to handle pressing Enter in the text field
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="flex w-full items-center gap-2" onClick={(e) => e.stopPropagation()}>
      <div className="flex w-full items-center gap-2">
        <div className="flex w-full flex-col gap-1">
          <p className="mb-1 pr-2 text-xs font-normal text-gray-500">
            Enter verbatim date in any format, e.g. 2001, 9th June 2003, 2006-2007, September 2009
          </p>

          <div className="group flex w-full items-center transition-colors hover:border-gray-300">
            <div className="flex w-full items-center rounded border border-gray-200 bg-gray-50 transition-all focus-within:border-blue-500 focus-within:bg-white focus-within:ring-1 focus-within:ring-blue-500">
              <input
                className="w-full border-0 bg-transparent px-2 py-1 text-xs text-gray-700 outline-none"
                type="text"
                value={value}
                onChange={handleTextChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter date..."
                autoFocus
              />
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isLoading}
                className="flex h-full items-center px-2 text-gray-500 transition-colors hover:text-blue-500"
              >
                {isLoading ? (
                  <div className="size-3.5 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
                ) : (
                  <ArrowRightCircleIcon className="size-3.5" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateInput;
